// extracted by css-extract-rspack-plugin
export default {"Blankslate":"archive-empty-states-module__Blankslate__wsQwj","Octicon":"archive-empty-states-module__Octicon__f1bKU"};